import { render, staticRenderFns } from "./CheckoutItemsTemplate.vue?vue&type=template&id=4f1cd23f&"
import script from "./CheckoutItemsTemplate.vue?vue&type=script&lang=js&"
export * from "./CheckoutItemsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports